import { encode } from '@msgpack/msgpack';
import { SITE_URL } from '@educraft/base';

function safeBase64Bytes(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function urlQr(data: object, siteUrl?: string): string {
  const base = siteUrl || SITE_URL || 'https://qr.beil.cz/';
  const url = base.endsWith('/') ? base : `${base  }/`;
  return `${url  }#${  safeBase64Bytes(encode(data))}`;
}
